import { render, staticRenderFns } from "./SharedStockItemSalesByCustomerTable.vue?vue&type=template&id=35b62bdb"
import script from "./SharedStockItemSalesByCustomerTable.vue?vue&type=script&lang=ts"
export * from "./SharedStockItemSalesByCustomerTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports